import { render, staticRenderFns } from "./GroupPricingDoseDistribuitionVacina.vue?vue&type=template&id=f2766e3a&"
import script from "./GroupPricingDoseDistribuitionVacina.vue?vue&type=script&lang=js&"
export * from "./GroupPricingDoseDistribuitionVacina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports